import React from 'react';

// Types
import { NewFeatureCarouselModalType } from 'Dashboard/components/NewFeatureCarouselModal/NewFeatureCarouselModal.types';
import { Illustrations } from 'Wpds/components/illustration';

// Constants
import Colors from 'Wpds/colors/ColorConstants';

// Components
import ExternalLinksConstants from 'Shared/constants/ExternalLinks.constants';
import WpLink from 'Wpds/components/link/WpLink';
import { WpIcon } from 'Wpds/components/icon';

// Slugs in this file are primarily used for
// tracking purpose. Please be mindful if a
// change to a slug is needed
const slugPrefix = 'pi_admin_console_intro_modal';

export const PiAdminConsoleIntroModalData = {
  slug: slugPrefix,
  slides: [
    {
      slug: 'start-slide',
      title: 'Your employee directory is now located in PI Administration.',
      description: `Invite users, edit employee details, manage settings, and more, all in one place. You can even upload an org file to make updates to your whole directory at once.`,
      imageBgColor: Colors.purple[25],
      imageWidth: '180px',
      image: Illustrations.person_with_megaphone_with_white_bg,
      nextBtnLabel: 'Got it!',
      footer: (
        <WpLink href={ExternalLinksConstants.pi_2_admin_employee_dirextory_documentation_link}>
          <WpIcon name="external-link" />
          Navigating your employee directory
        </WpLink>
      ),
    },
  ],
} as NewFeatureCarouselModalType;
